import { render, staticRenderFns } from "./TableBrancePersonal.vue?vue&type=template&id=21f5a948"
import script from "./TableBrancePersonal.vue?vue&type=script&lang=js"
export * from "./TableBrancePersonal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports